module.exports = __webpack_public_path__ + "static/media/download.b571bea6.svg";